var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import FilterSourceService from "../../../../../Services/FilterSource.service";
import AvisoLayout from "../../../../../../components/shared/layout";
import FilterSourceSelector from "../../../../Containers/FilterSourceSelector";
import { AlertError } from "../../../../UI/StandardAlerts/StandardAlerts";
import { reportSourceCreatePath } from "../../ReportRoutes";
import { useVirtualizedApp } from "../../../../Hooks/useVirtualizedApp";
import ErrorService from "../../../../../Services/Shared/Error.service";
const ReportCreateSourceIndex = (props) => {
    const [filterSources, setFilterSources] = React.useState([]);
    const virtualizedApp = useVirtualizedApp();
    const [isLoading, setIsLoading] = React.useState(false);
    const [error, setError] = React.useState(null);
    function fetchFilterSources() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                setError(null);
                setIsLoading(true);
                const loadedFilterSources = yield FilterSourceService.fetchFilterSources();
                setFilterSources(loadedFilterSources);
            }
            catch (e) {
                setError({
                    message: "Error loading filter sources",
                    detail: ErrorService.getMessageFromError(e),
                });
            }
            finally {
                setIsLoading(false);
            }
        });
    }
    function selectFilterSource(filterSource) {
        props.history.push(reportSourceCreatePath({ id: filterSource.filterSourceId }));
    }
    React.useEffect(() => {
        fetchFilterSources();
    }, []);
    return (_jsx("div", { className: "fullMinHeightMinusPrimaryNav bg-light", children: _jsxs(AvisoLayout, { renderNav: () => (_jsxs("button", { type: "button", className: "btn btn-link", onClick: () => {
                    fetchFilterSources();
                }, children: [_jsx("span", { className: "fas fa-sync" }), " Refresh"] })), children: [_jsx(FilterSourceSelector, { isLoading: isLoading, filterSources: filterSources, onFilterSourceClick: (filterSource) => {
                        selectFilterSource(filterSource);
                    } }), error && _jsx(AlertError, { message: error.message, detail: error.detail })] }) }));
};
export default ReportCreateSourceIndex;
